import React from 'react';
import I18n from 'i18n-js';
import { string } from 'prop-types';
import cwoModuleConfig from '../helpers/cwoModuleConfig';

const CwoModuleLabel = ({ cwoModule = '' }) => (
  <div className="tickets-index-page__cwo-select-label">
    <div className="tickets-index-page__cwo-select-label__icon">
      {cwoModuleConfig[cwoModule]?.icon}
    </div>
    <div className="tickets-index-page__cwo-select-label__text">
      {I18n.t(`tickets.cwo_modules.${cwoModule}`)}
    </div>
  </div>
);

CwoModuleLabel.propTypes = {
  cwoModule: string,
};

export default CwoModuleLabel;
